import { declineOrderActions } from "actions/declineOrderActions";
import { fromJS } from "immutable";

const initialState = fromJS({
  isLoading: true,
  data: {
    message: null,
  },
  errors: [],
});

export default (state = initialState, action) => {
  const payload = action.payload;

  switch (action.type) {
    case declineOrderActions.startLoader:
      return state.set("isLoading", true);
    case declineOrderActions.success:
      return state
        .merge({
          isLoading: false,
          errors: [],
        })
        .set("data", fromJS(payload.data));
    case declineOrderActions.failure:
      return state
        .merge({
          isLoading: false,
          data: { message: null },
        })
        .set("errors", fromJS(payload.errors));
    case declineOrderActions.reset:
      return initialState;
    default:
      return state;
  }
};
